<template>
  <div class="row">
    <div class="col-lg-4">
      <div class="col-12">
        <div class="white-box text-end">
          <div class="line-cart">
            <LineChart :chartData="lineData" :options="options" />
          </div>
          <div class="text-area right">
            <h2 class="bold-19 text-gradient mb-2">
              {{ $t("problems.repair") }}
            </h2>
            <h2 class="bold-40 text-gradient">{{ data["8_count"] ?? "0" }}</h2>
          </div>
        </div>
        <button
          class="btn btn-type-4 w-100 text-center mb-3"
          v-on:click="showAddModal(8)"
        >
          <span class="semibold-14 text-gradient">
            {{ $t("problems.new2") }}
          </span>
        </button>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="col-12">
        <div class="white-box text-end">
          <div class="line-cart">
            <LineChart :chartData="lineData2" :options="options" />
          </div>
          <div class="text-area right">
            <h2 class="bold-19 text-gradient mb-2">
              {{ $t("problems.waste") }}
            </h2>
            <h2 class="bold-40 text-gradient">{{ data["7_count"] ?? "0" }}</h2>
          </div>
        </div>
        <button
          class="btn btn-type-4 w-100 text-center mb-3"
          v-on:click="showAddModal(7)"
        >
          <span class="semibold-14 text-gradient">
            {{ $t("problems.new2") }}
          </span>
        </button>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="col-12">
        <div class="white-box text-end">
          <div class="line-cart">
            <LineChart :chartData="lineData3" :options="options" />
          </div>
          <div class="text-area right">
            <h2 class="bold-19 text-gradient mb-2">
              {{ $t("problems.deficit") }}
            </h2>
            <h2 class="bold-40 text-gradient">{{ data["4_count"] ?? "0" }}</h2>
          </div>
        </div>
        <button
          class="btn btn-type-4 w-100 text-center mb-3"
          v-on:click="showAddModal(4)"
        >
          <span class="semibold-14 text-gradient">
            {{ $t("problems.new2") }}
          </span>
        </button>
      </div>
    </div>
    <div class="col-lg-12">
      <div v-for="item in items" :key="item.id" class="white-box p-1">
        <div class="row mt-4 mb-1 p-0 ms-2">
          <div class="col-6">
            <h3 class="bold-16">
              {{ item?.id }} -
              {{ formatDate(item.created_at) }}
            </h3>
            <div class="regular-12 text-muted" v-if="item.user">
              {{ $t("problems.createdBy") }}: {{ item.user.first_name }} {{ item.user.last_name }}
            </div>
          </div>
          <div class="col-6 text-end d-flex justify-content-end align-items-center">
            <span
              class="badge me-3"
              :class="itemOperationTypes[item.operation_type].color"
            >
              {{ itemOperationTypes[item.operation_type].name }}
            </span>
            <span v-if="warehouse === null" class="me-3">{{
              item.warehouse
            }}</span>
            <div class="d-flex no-wrap dropdown">
              <button
                id="printBtn"
                class="btn btn-transparent dropdown-btn"
                data-bs-toggle="dropdown"
                aria-expanded="true"
                :disabled="loadPrintBtn"
              >
                <span
                  class="rounded-box ms-auto me-auto spin-dark"
                  :class="{ 'loading-spin': loadPrintBtn }"
                  ref="btn7"
                  data-bs-placement="top"
                  :title="$t(`problems.print`)"
                >
                  <BaseIcon name="printer" />
                </span>
              </button>
              <div
                class="dropdown-menu"
                aria-labelledby="Printing options"
                data-popper-placement="bottom-start"
              >
                <div class="row">
                  <div class="col-12">
                    <button
                      class="dropdown-item regular-12"
                      v-on:click="downloadProductsLabels(item.id)"
                    >
                      <BaseIcon name="barcode" />
                      {{ $t("problems.productLabels") }}
                    </button>
                    <button
                      class="dropdown-item regular-12"
                      v-on:click="downloadBoxesLabels(item.id)"
                    >
                      <BaseIcon name="box" />
                      {{ $t("problems.boxLabels") }}
                    </button>
                    <button
                      class="dropdown-item regular-12"
                      v-on:click="downloadXlsx(item.id)"
                    >
                      <BaseIcon name="active" />
                      {{ $t("problems.xlsx") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <OneByOneTable
          v-model:rows="rows"
          :showAdd="false"
          v-model:items="item.itemOperations"
          type="products"
          :no-min-height="true"
          check-delete-row="left_quantity"
          v-on:delete="ShowdeleteRowModal"
        />
      </div>
    </div>
    <NewManualIncoming
      ref="newManualModal"
      v-on:newItem="newItem"
      :type="selectedType"
    />
    <ConfirmModal
        ref="noWarehouseModal"
        :title="$t(`outgoing.noWarehouseSelected`)"
        text="please select a warehouse before adding a new income!"
        :show-ok="false"
        cancel-button="Ok"
    />
    <ConfirmModal
      ref="rowDeleteModal"
      :title="$t(`problems.deleteRow`)"
      :text="`<ul><li>You will remove ${deleteObject?.name} from the problems<b></li><li>You can't undo this action</li></ul><p>Are you sure you want to delete?</p>
             <div class='mt-3'><label class='form-label'>How many items do you want to remove?</label><input type='number' id='bulkDeleteQuantity' class='form-control' value='1' min='1' max='${deleteObject?.left_incoming}'></div>`"
      :cancel-button="`No, keep ${deleteObject?.name}`"
      :ok-button="`Yes, delete ${deleteObject?.name}`"
      v-on:success="deleteRow"
    />
  </div>
</template>

<script>
import { LineChart } from "vue-chart-3";
import OneByOneTable from "../../components/lists/OneByOneTable";
import NewManualIncoming from "../../components/modals/NewManualIncoming";
import ConfirmModal from "@/components/modals/ConfirmModal";
import { useStore } from "vuex";
import http from "../../modules/http";
import date from "@/modules/date";
import ItemOperationTypes from "../../modules/ItemOperationTypes";
import BaseIcon from "../../components/icons/BaseIcon.vue";
import printJS from "print-js";
import tenant from "../../modules/tenant";
export default {
  name: "Problems",
  components: {
    BaseIcon,
    ConfirmModal,
    NewManualIncoming,
    OneByOneTable,
    LineChart,
  },

  data() {
    return {
      store: useStore(),
      itemOperationTypes: ItemOperationTypes,
      selectedType: null,
      deleteObject: {},
      options: {
        padding: 0,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            display: false,
            grid: {
              display: false,
            },
          },
          y: {
            display: false,
            grid: {
              display: false,
            },
          },
        },
      },
      lineData: {
        labels: [],
        datasets: [
          {
            label: "Current value",
            data: [],
            lineTension: 0.45,
            borderColor: "rgba(160,85,224,1)",
            backgroundColor: "rgba(160,85,224,0.3)",
            fill: true,
          },
        ],
      },
      lineData2: {
        labels: [],
        datasets: [
          {
            label: "Current value",
            data: [],
            lineTension: 0.45,
            borderColor: "rgba(160,85,224,1)",
            backgroundColor: "rgba(160,85,224,0.3)",
            fill: true,
          },
        ],
      },
      lineData3: {
        labels: [],
        datasets: [
          {
            label: "Current value",
            data: [],
            lineTension: 0.45,
            borderColor: "rgba(160,85,224,1)",
            backgroundColor: "rgba(160,85,224,0.3)",
            fill: true,
          },
        ],
      },
      data: {},
      rows: [
        {
          name: "image",
          key: "image",
          type: "image",
          show: true,
          editable: false,
        },
        {
          name: "Serial",
          key: "serial",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: this.$t("problems.color"),
          key: "characteristics_1", //TODO tmp add backend
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: this.$t("problems.size"),
          key: "characteristics_2",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: this.$t("problems.description"),
          key: "description",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: this.$t("problems.name"),
          key: "name",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: this.$t("problems.problemCategory"),
          key: "problem_category_name",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: this.$t("problems.quantity"),
          key: "left_quantity",
          type: "number",
          show: true,
          editable: false,
          colorByValue: true,
        },
        {
          name: this.$t("problems.originalQuantity"),
          key: "quantity",
          type: "number",
          show: true,
          editable: false,
        },
        {
          name: "SKU",
          key: "sku",
          type: "string",
          show: true,
          editable: false,
        },
      ],
      filtersTimeOut: null,
      firstLoad: true,
      page: 1,
      items: null,
      loadPrintBtn: false,
    };
  },
  computed: {
    warehouse() {
      return this.store.state.topBar.warehouse;
    },
    warehouses() {
      return this.store.state.warehouses;
    },
    date() {
      return this.store.state.topBar.date;
    },
    q() {
      return this.store.state.topBar.q;
    },
    mediaServer() {
      return tenant.getAppMediaUrl();
    },
    filterPage() {
      return this.store.state.filterPage;
    },
    filters() {
      return this.store.state.filters?.problems;
    },
  },
  mounted() {
    this.loadData();
  },
  watch: {
    warehouse() {
      this.loadData();
    },
    q() {
      if (this.filtersTimeOut !== null) {
        clearTimeout(this.filtersTimeOut);
      }
      this.filtersTimeOut = setTimeout(() => {
        this.filtersTimeOut = null;
        this.page = 1;
        this.loadData();
      }, 450);
    },
    filters: {
      deep: true,
      handler() {
        if (this.filterPage !== "problems" || this.firstLoad) {
          setTimeout(() => {
            this.firstLoad = false;
          }, 100);
          return;
        }
        if (this.filtersTimeOut !== null) {
          clearTimeout(this.filtersTimeOut);
        }
        this.filtersTimeOut = setTimeout(() => {
          this.filtersTimeOut = null;
          this.page = 1;
          this.loadData();
        }, 450);
      },
    },
    date: {
      deep: true,
      handler() {
        this.loadData();
      },
    },
  },
  methods: {
    downloadProductsLabels(id) {
      const _this = this;
      this.loadPrintBtn = true;

      let url = `${tenant.getApiBaseUrl()}/production/${id}/barcode/?_token=${
        this.store.state.token
      }`;

      if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
        window.open(url, "_blank");
        _this.loadPrintBtn = false;
      } else {
        printJS({
          printable: url,
          onLoadingEnd: function () {
            _this.loadPrintBtn = false;
          },
        });
      }
    },
    downloadXlsx(id) {
      window.open(
        `${tenant.getApiBaseUrl()}/warehouses/outgoing/${id}/xlsx?_token=${
          this.store.state.token
        }`,
        "_blank"
      );
    },
    downloadBoxesLabels(id) {
      const _this = this;
      this.loadPrintBtn = true;
      let url = `${tenant.getApiBaseUrl()}/production/${id}/box-label/?_token=${
        this.store.state.token
      }`;
      if (navigator.userAgent.toLowerCase().indexOf("firefox") > -1) {
        window.open(url, "_blank");
        _this.loadPrintBtn = false;
      } else {
        printJS({
          printable: url,
          onLoadingEnd: function () {
            _this.loadPrintBtn = false;
          },
        });
      }
    },
    formatDate(val) {
      return date.format(val, true, true);
    },
    appUrl() {
      return tenant.getApiBaseUrl();
    },
    getUrl(exp = false) {
      let url =
        (exp ? this.appUrl() : "") +
        "/warehouses/outgoing/problems" +
        (exp ? "/export/xlsx" : "") +
        "?page=" +
        this.page +
        (exp ? "&_token=" + this.store.state.token : "") +
        (this.warehouse ? "&warehouse=" + this.warehouse : "") +
        (this.q ? "&q=" + this.q : "") +
        (this.date[0]
          ? "&from=" + this.date[0].toISOString().split("T")[0]
          : "") +
        (this.date[1] ? "&to=" + this.date[1].toISOString().split("T")[0] : "");

      if (this.filters && Object.keys(this.filters)?.length > 0) {
        for (const filter in this.filters) {
          if (filter === "characteristics") {
            for (const charId in this.filters[filter].value) {
              const charValues = this.filters[filter].value[charId];
              if (Array.isArray(charValues)) {
                for (const value of charValues) {
                  url += `&characteristics[${charId}][]=${value}`;
                }
              } else if (charValues) {
                url += `&characteristics[${charId}]=${charValues}`;
              }
            }
          } else if (Array.isArray(this.filters[filter].value)) {
            for (const value of this.filters[filter].value) {
              url += `&${filter}[]=${value}`;
            }
          } else {
            url += `&${filter}=${this.filters[filter].value}`;
          }
        }
      }

      return url;
    },
    loadData() {
      if (this.page === 1) {
        this.items = null;
      }

      if (this.filterPage !== "problems") {
        this.$store.commit("setFilterOptions", []);

        http
          .fetch("/products/products/characteristics?language=en")
          .then((data) => {
            let filterOptions = [];
            this.$store.commit("setFilterPage", "problems");

            filterOptions.push({
              name: this.$t("problems.type"),
              type: "string",
              key: "type",
              value: {
                4: true,
                7: true,
                8: true,
              },
              values: [
                { id: 4, name: this.$t("problems.deficit") },
                { id: 7, name: this.$t("problems.waste") },
                { id: 8, name: this.$t("problems.repair") },
              ],
              valueName: "name",
            });

            this.filters["type"] = {
              value: [4, 7, 8],
            };

            filterOptions.push({
              name: "Show deleted",
              type: "boolean",
              key: "show_deleted",
              value: {},
              values: [
                { id: 1, value: "Yes" },
                { id: 0, value: "No" },
              ],
            });

            for (const obj of data) {
              let max =
                  obj.characteristics_values_max_val_double !== null
                      ? obj.characteristics_values_max_val_double
                      : obj.characteristics_values_max_val_int;
              filterOptions.push({
                name: obj.name,
                type: obj.type,
                key: "characteristics[" + obj.id + "]",
                value: obj.type === "number" ? [0, max] : {},
                max: max,
                values: obj?.characteristics_values,
                prefix: obj?.prefix,
                postfix: obj?.postfix,
              });
            }


            this.$store.commit("setFilterOptions", filterOptions);
          });
      }

      http.fetch(this.getUrl()).then((data) => {
        for (const item of data.data) {
          for (const product of item.itemOperations) {
            product.image =
              product.image !== null
                ? product.image.indexOf("http") === 0
                  ? product.image
                  : this.mediaServer + "/" + product.image
                : null;
          }
        }
        this.data = data;
        this.lineData.labels = Object.keys(data["8_grouped"]);
        this.lineData.datasets[0].data = Object.values(data["8_grouped"]);
        this.lineData2.labels = Object.keys(data["7_grouped"]);
        this.lineData2.datasets[0].data = Object.values(data["7_grouped"]);
        this.lineData3.labels = Object.keys(data["4_grouped"]);
        this.lineData3.datasets[0].data = Object.values(data["4_grouped"]);

        this.items = data.data;
      });
    },
    showAddModal(type) {
      this.selectedType = type;
      if (this.warehouse === null) {
        this.$refs.noWarehouseModal.showModal();
      } else {
        this.$refs.newManualModal.showModal();
      }
    },
    ShowdeleteRowModal(e) {
      console.log(e);
      this.deleteObject = e;
      this.$refs.rowDeleteModal.showModal();
    },
    deleteRow() {
      const quantity = document.getElementById("bulkDeleteQuantity")?.value ?? 1;
      http
        .fetch(
          `/warehouses/income/${this.deleteObject.warehouse_operation_id}/packaging`,
          {
            item: this.deleteObject.id,
            quantity: quantity,
          },
          true
        )
        .then((data) => {
          console.log(data);
          this.page = 1;
          this.loadData();
        });
    },
    newItem(data) {
      this.loadData();
      console.log(data);
      // this.items.unshift(data);
      // this.tableKey++;
    },
  },
};
</script>
